import React from 'react';
import {Field, FieldArray} from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import FormLabel from '../../components/FormLabel'
import FormAutoComplete2 from '../../components/FormAutoComplete2'
import FormDatePicker from '../../components/FormDatePicker'
import styles from '../../styles'
import FormText from "../../components/FormText";
import * as commons from "../../commons";
import * as colors from "material-ui/styles/colors";
import FormOrderAmmounts from "../../components/FormOrderAmmounts";
import FormClaimAmmounts from "../../components/FormClaimAmmounts";
import {Card, CardHeader, CardText} from "material-ui/Card";

const dataSourceConfig = {
    text: 'textKey',
    value: 'valueKey',
};

class YosanBasicForm extends React.Component {

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {

        const {
            orderOpen,
            claimOpen,
            auth,
            allOrderAmmount,
            allOrderAmmountBudget,
            allClaimAmmount,
            status,
        } = this.props

        return (

            <div>

                <div className="row" style={{marginBottom: 30}}>

                    <div className="col-6">

                        <Paper style={styles.yosanContents}>
                            <h4 style={styles.yosanFormTitle}>見積り情報</h4>
                            <Divider/>

                            <div className='row'>
                                <div className="col-6">
                                    <Field
                                        name="estimateCode"
                                        component={FormText}
                                        label="見積り番号"
                                        style={{width: '100%'}}
                                        disabled={status === 3}
                                    />
                                </div>
                                <div className="col-6">
                                    <Field
                                        name="estimateAmmount"
                                        component={FormText}
                                        normalize={commons.dispMoney}
                                        format={commons.dispMoney}
                                        label="見積り金額"
                                        style={{width: '100%'}}
                                        disabled={status === 3}
                                    />
                                </div>
                            </div>

                        </Paper>

                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col-6">
                        <Card initiallyExpanded={true}>
                            <CardHeader
                                title={'受注金額情報'}
                                actAsExpander={true}
                                showExpandableButton={true}
                                titleStyle={{...styles.yosanFormTitle, marginButtom: 0}}
                                style={{paddingBottom: 0}}
                            >
                            </CardHeader>
                            <CardText expandable={false} style={{paddingTop: 0}}>
                                <div className="row" style={{marginBottom: 5}}>
                                    <div className="col">
                                        <span style={{color: colors.grey600, fontSize: 11}}>
                                            合計 (予)
                                            <span style={{marginLeft: 10, fontSize: 23}}>
                                            {commons.dispMoney(allOrderAmmountBudget)}
                                            </span>
                                        </span>
                                        <span style={{marginLeft: 20, color: colors.grey600, fontSize: 11}}>
                                            合計 (実)
                                            <span style={{marginLeft: 10, fontSize: 23}}>
                                            {commons.dispMoney(allOrderAmmount)}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col"}>
                                        <Divider/>
                                    </div>
                                </div>
                            </CardText>
                            <CardText expandable={true}>
                                <div className='row'>
                                    <div className="col-4">
                                        <Field
                                            name="orderAmmountBudget"
                                            component={FormText}
                                            normalize={commons.dispMoney}
                                            format={commons.dispMoney}
                                            label="受注金額(予)"
                                            style={{width: '100%'}}
                                            disabled={status === 3}
                                        />
                                    </div>
                                    <div className="col-4">
                                        <Field
                                            name="orderAmmount"
                                            component={FormText}
                                            normalize={commons.dispMoney}
                                            format={commons.dispMoney}
                                            label="受注金額(実)"
                                            style={{width: '100%'}}
                                            disabled={status === 3 || auth.user.permission != 2}
                                        />
                                    </div>
                                </div>
                                <FieldArray name="orderAmmounts" component={FormOrderAmmounts} status={status} auth={auth}/>
                            </CardText>
                        </Card>
                        {/*<Paper style={styles.yosanContents}>*/}
                            {/*<h4 style={{...styles.yosanFormTitle, marginBottom: 5}}>*/}
                                {/*受注金額情報*/}
                            {/*</h4>*/}
                            {/*<div style={{marginTop: 5, marginBottom: 5}}>*/}
                                {/*<span style={{color: colors.grey600, fontSize: 12}}>*/}
                                    {/*予：*/}
                                    {/*<span style={{fontSize: 25}}>*/}
                                        {/*{commons.dispMoney(allOrderAmmountBudget)}*/}
                                    {/*</span>*/}
                                {/*</span>*/}
                                {/*<span style={{marginLeft: 20, color: colors.grey600, fontSize: 12}}>*/}
                                    {/*実：*/}
                                    {/*<span style={{fontSize: 25}}>*/}
                                        {/*{commons.dispMoney(allOrderAmmount)}*/}
                                    {/*</span>*/}
                                {/*</span>*/}
                            {/*</div>*/}
                            {/*<Divider/>*/}

                            {/*<div className='row'>*/}
                                {/*<div className="col-4">*/}
                                    {/*<Field*/}
                                        {/*name="orderAmmountBudget"*/}
                                        {/*component={FormText}*/}
                                        {/*normalize={commons.dispMoney}*/}
                                        {/*format={commons.dispMoney}*/}
                                        {/*label="受注金額(予)"*/}
                                        {/*style={{width: '100%'}}*/}
                                        {/*disabled={status === 3}*/}
                                    {/*/>*/}
                                {/*</div>*/}
                                {/*<div className="col-4">*/}
                                    {/*<Field*/}
                                        {/*name="orderAmmount"*/}
                                        {/*component={FormText}*/}
                                        {/*normalize={commons.dispMoney}*/}
                                        {/*format={commons.dispMoney}*/}
                                        {/*label="受注金額(実)"*/}
                                        {/*style={{width: '100%'}}*/}
                                        {/*disabled={status === 3 || auth.user.permission != 2}*/}
                                    {/*/>*/}
                                {/*</div>*/}
                            {/*</div>*/}

                            {/*<FieldArray name="orderAmmounts" component={FormOrderAmmounts} status={status} auth={auth}/>*/}

                        {/*</Paper>*/}
                    </div>

                    <div className="col-6">

                        <Card initiallyExpanded={true}>
                            <CardHeader
                                title={'請求金額情報'}
                                actAsExpander={true}
                                showExpandableButton={true}
                                titleStyle={{...styles.yosanFormTitle, marginButtom: 0}}
                                style={{paddingBottom: 0}}
                            >
                            </CardHeader>
                            <CardText expandable={false} style={{paddingTop: 0}}>
                                <div className="row" style={{marginBottom: 5}}>
                                    <div className="col">
                                        <span style={{color: colors.grey600, fontSize: 12}}>
                                            合計
                                            <span style={{marginLeft: 10, fontSize: 23}}>
                                                {commons.dispMoney(allClaimAmmount)}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col"}>
                                        <Divider/>
                                    </div>
                                </div>
                            </CardText>
                            <CardText expandable={true}>
                                {/*<div className='row'>*/}
                                    {/*<div className="col-4">*/}
                                        {/*<Field*/}
                                            {/*name="claimAmmount"*/}
                                            {/*component={FormText}*/}
                                            {/*normalize={commons.dispMoney}*/}
                                            {/*format={commons.dispMoney}*/}
                                            {/*label="請求金額"*/}
                                            {/*style={{width: '100%'}}*/}
                                            {/*disabled={status === 3}*/}
                                        {/*/>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-4">*/}
                                        {/*<Field*/}
                                            {/*name="claimComment"*/}
                                            {/*component={FormText}*/}
                                            {/*normalize={commons.dispMoney}*/}
                                            {/*format={commons.dispMoney}*/}
                                            {/*label="備考"*/}
                                            {/*style={{width: '100%'}}*/}
                                            {/*disabled={status === 3 || auth.user.permission != 2}*/}
                                        {/*/>*/}
                                    {/*</div>*/}
                                {/*</div>*/}

                                <FieldArray name="claimAmmounts" component={FormClaimAmmounts} status={status} auth={auth}/>
                            </CardText>
                        </Card>

                        {/*<Paper style={styles.yosanContents}>*/}
                            {/*<h4 style={{...styles.yosanFormTitle, marginBottom: 5}}>*/}
                                {/*請求金額情報*/}
                            {/*</h4>*/}
                            {/*<div style={{marginTop: 5, marginBottom: 5}}>*/}
                                {/*<span style={{color: colors.grey600, fontSize: 12}}>*/}
                                    {/*合計：*/}
                                    {/*<span style={{fontSize: 25}}>*/}
                                        {/*{commons.dispMoney(allClaimAmmount)}*/}
                                    {/*</span>*/}
                                {/*</span>*/}
                            {/*</div>*/}
                            {/*<Divider/>*/}

                            {/*<div className='row'>*/}
                                {/*<div className="col-4">*/}
                                    {/*<Field*/}
                                        {/*name="claimAmmount"*/}
                                        {/*component={FormText}*/}
                                        {/*normalize={commons.dispMoney}*/}
                                        {/*format={commons.dispMoney}*/}
                                        {/*label="請求金額"*/}
                                        {/*style={{width: '100%'}}*/}
                                        {/*disabled={status === 3}*/}
                                    {/*/>*/}
                                {/*</div>*/}
                                {/*<div className="col-4">*/}
                                    {/*<Field*/}
                                        {/*name="claimComment"*/}
                                        {/*component={FormText}*/}
                                        {/*normalize={commons.dispMoney}*/}
                                        {/*format={commons.dispMoney}*/}
                                        {/*label="備考"*/}
                                        {/*style={{width: '100%'}}*/}
                                        {/*disabled={status === 3 || auth.user.permission != 2}*/}
                                    {/*/>*/}
                                {/*</div>*/}
                            {/*</div>*/}

                            {/*<FieldArray name="claimAmmounts" component={FormClaimAmmounts} status={status} auth={auth}/>*/}

                        {/*</Paper>*/}

                    </div>

                </div>

            </div>

        );

    }

}

export default YosanBasicForm




// WEBPACK FOOTER //
// ./src/containers/yosan/YosanTransactionAmountForm.js